import { render, staticRenderFns } from "./my-phone.vue?vue&type=template&id=e7b542ec&scoped=true&"
import script from "./my-phone.vue?vue&type=script&lang=js&"
export * from "./my-phone.vue?vue&type=script&lang=js&"
import style0 from "./my-phone.vue?vue&type=style&index=0&id=e7b542ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b542ec",
  null
  
)

export default component.exports